import template from './checkboxitem.html'
import ko from 'knockout'
// import stringHash from 'string-hash'

const FIELDIDAFFIX = '_checkbox'
function init (params) {
  this.label = params.label
  this.disabled = params.disabled || ko.observable(false)
  this.secondarylabel = params.secondarylabel || ''
  // 选项对应的值
  this.value = params.value
  this.checked = params.checked || ko.observable(false)
  this.falseValue = params.falseValue || false
  this.clickBubble = !!params.clickBubble
  this.trueValue = params.trueValue ? params.trueValue : true
  this.fieldid = params.fieldid + this.value + FIELDIDAFFIX
  // 当在checkbox中使用时，valueList表示所有选中的值
  params.valueList = params.valueList || []
  // 初始化，如果
  if (params.valueList.indexOf(this.value) >= 0) {
    this.checked(this.trueValue)
  }
  params.valueList.subscribe && params.valueList.subscribe(val => {
    // 统一需要转成字符串来判断
    var stringArray = val.map(item => {
      return item ? (item + '') : ''
    })
    // 统一用string来判断
    if (stringArray.indexOf(this.value + '') >= 0) {
      this.checked(this.trueValue)
    } else {
      this.checked(this.falseValue)
    }
  })
  this.checked.subscribe(val => {
    // 统一需要转成字符串来判断
    var stringArray = ko.isObservable(params.valueList) ? params.valueList().map((item) => {
      return item ? (item + '') : ''
    }) : []
    let index = stringArray.indexOf(this.value + '')
    if (index < 0 && val) {
      params.valueList.push(this.value)
    } else if (!val && index >= 0) {
      params.valueList.splice(index, 1)
    }
  })
  // checkbox重构，不和input进行绑定，在modal+checkbox-grid场景 全选始终无法选中，
  // 于是干脆不绑定了，直接用 试一下
  this.hanldeClick = (data, event) => {
    if (!ko.utils.unwrapObservable(this.disabled)) {
      if (data.checked() === this.trueValue) {
        data.checked(this.falseValue)
      } else {
        data.checked(this.trueValue)
      }
    }
  }
}
export default {
  name: 'checkbox-item',
  init,
  template
}



// WEBPACK FOOTER //
// ./src/components/checkbox/checkboxitem.js